export enum ViewType {
  TIMELINE = 'timeline',
  CALENDAR = 'calendar',
}

export enum NavigationDirection {
  PREV = 'PREV',
  NEXT = 'NEXT',
  TODAY = 'TODAY',
}

export enum ZoomLevel {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export enum GroupByOption {
  LIST = 'list',
  MEMBER = 'member',
  LABEL = 'label',
  NONE = 'none',
}
